import { render } from "./ChangeEmailModal.vue?vue&type=template&id=d6415e8e&scoped=true"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=js"

import "./ChangeEmailModal.vue?vue&type=style&index=0&id=d6415e8e&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6415e8e"]])

export default __exports__